import React from 'react';
import { formatCurrencyAsText } from '~/utils/functions';
import { useCadastroProducao } from '../../hook/useCadastroProducao';
import { Container, TableTitle, StyledTable, Th, Td } from './style';

export const Footer: React.FC = () => {
  const {
    produtosRows,
    custoSemImposto,
    valCustoReceita,
    qtdTotReceita,
    qtdTotProducao,
    valCustoProducao,
    valCustoFinal,
    qtdRendeKG,
  } = useCadastroProducao();

  return (
    <Container>
      <TableTitle>
        {produtosRows.length > 0
          ? `É preciso de  ${formatCurrencyAsText(
              qtdRendeKG,
              3,
              3,
            )} kg para render 1 kg`
          : `É preciso de 0,000 kg para render 1 kg`}
      </TableTitle>

      <StyledTable>
        <thead>
          <tr>
            <Th>Custo s/ Imp</Th>
            <Th>Custo Receita</Th>
            <Th>Qtd. Receita</Th>
            <Th>Qtd. Produção</Th>
            <Th>Custo Produção</Th>
            <Th>Custo Final</Th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <Td>
              R$
              {produtosRows.length > 0
                ? formatCurrencyAsText(custoSemImposto, 2, 2)
                : '0,00'}
            </Td>
            <Td>
              R$
              {produtosRows.length > 0
                ? formatCurrencyAsText(valCustoReceita, 2, 2)
                : '0,00'}
            </Td>
            <Td>
              {produtosRows.length > 0
                ? formatCurrencyAsText(qtdTotReceita, 3, 3)
                : '0,000'}
            </Td>
            <Td>
              {produtosRows.length > 0
                ? formatCurrencyAsText(qtdTotProducao, 3, 3)
                : '0,000'}
            </Td>
            <Td>
              R$
              {produtosRows.length > 0
                ? formatCurrencyAsText(valCustoProducao, 2, 2)
                : '0,00'}
            </Td>
            <Td>
              R$
              {produtosRows.length > 0
                ? formatCurrencyAsText(valCustoFinal, 2, 2)
                : '0,00'}
            </Td>
          </tr>
        </tbody>
      </StyledTable>
    </Container>
  );
};
